module.exports = __webpack_public_path__ + "static/media/Poochyena_gaussian2.3cee7823.png";